import { useState } from "react";

import PlaceholderImage from "../PlaceholderImage";

type Props = {
  src?: string;
  alt: string;
  className?: string;
};

export function ImageWithFallback({ src, alt, className }: Props) {
  const [error, setError] = useState(false);

  if (!src || error) {
    return <PlaceholderImage className={className} />;
  }

  return (
    <img
      alt={alt}
      className={className}
      onError={() => setError(true)}
      src={src}
    />
  );
}

export default ImageWithFallback;
